import { endpoint, dateToServer } from 'services/Api';
import { RESOURCE as PARENT } from 'services/api/miniCalculators';

/**
 * Resource Endpoint.
 *
 * @type {String}
 */
const RESOURCE = 'monetary';

/**
 * Monetary Mini Calculator Endpoints:
 */
export default {
    /**
     * Interest Calculation Endpoint.
     *
     * @param  {} state
     *
     * @return {Promise}
     */
    interest(state) {
        return endpoint(`${PARENT}/${RESOURCE}`, 'interest', {
            date_from: state.dateFrom,
            date_to: state.dateTo,
            interest_rate: state.interestRate,
            principal_amount: state.principalAmount,
            interest_type: state.interestType,
            compound_frequency: state.compoundFrequency
        });
    },
    /**
     * Load the care rates
     *
     * @returns {*}
     */
    careRates() {
        return endpoint(`${PARENT}/${RESOURCE}`, 'care/load-care-rates');
    },
};



// WEBPACK FOOTER //
// ./src/services/api/mini-calculators/monetary.js